/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import { BookingsItems } from "@/models/api/bookings/BookingsList";
import {
  addBookingItemToExistGroup,
  getBookingItemGroupToEdit,
  removeBookingItemFromGroup,
  saveBookingItemGroup,
} from "@/requests/booking";
import { GroupBookingItemModel } from "@/models/api/bookings/GroupBookingItems";

export interface BookingsGroupStateInterface {
  isDialog: boolean;
  groupId: number | null;
  comment: string | null;
  bookingItems: Array<GroupBookingItemModel>;
  groupRecordStampId: null | number;
}

export const BookingsGroupState: BookingsGroupStateInterface = {
  isDialog: false,
  groupId: null,
  comment: null,
  bookingItems: [],
  groupRecordStampId: null,
};

const BookingsGroupModule = defineModule({
  state: BookingsGroupState as BookingsGroupStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setIsDialog(state, param: boolean) {
      state.isDialog = param;
    },
    setGroupId(state, param: number | null) {
      state.groupId = param;
    },
    setComment(state, param: string | null) {
      state.comment = param;
    },
    setBookingItems(state, bookingItems: Array<GroupBookingItemModel>) {
      state.bookingItems = bookingItems;
    },
    setRecordStamp(state, recordStampId: null | number) {
      state.groupRecordStampId = recordStampId;
    },
  },
  actions: {
    async openGroupDialog(context, param: BookingsItems) {
      const { commit, state, rootDispatch } = _moduleActionContext(context);
      commit.setComment(null);
      commit.setBookingItems([]);
      commit.setIsDialog(true);
      commit.setGroupId(param.bookingItemGroupId);
      const resp = await getBookingItemGroupToEdit(param.id, state.groupId);
      // noinspection ES6MissingAwait
      rootDispatch.bookings.getBookingsTable();
      commit.setGroupId(resp.id);
      commit.setComment(resp.comment);
      commit.setBookingItems(resp.bookingItems.map((v) => new GroupBookingItemModel(v)));
      commit.setRecordStamp(resp.recordStampId);
    },
    async addBookingItemToExistGroup(context, bookingItem: GroupBookingItemModel) {
      const { commit, state } = _moduleActionContext(context);
      await addBookingItemToExistGroup(bookingItem.id, state.groupId);
      const stateBookingItem = state.bookingItems.find((v) => v.id === bookingItem.id) as GroupBookingItemModel;
      stateBookingItem.isInGroup = true;
      commit.setBookingItems(state.bookingItems);
    },
    async removeBookingItemFromExistGroup(context, bookingItem: GroupBookingItemModel) {
      const { commit, state } = _moduleActionContext(context);
      await removeBookingItemFromGroup(bookingItem.id, state.groupId);
      const stateBookingItem = state.bookingItems.find((v) => v.id === bookingItem.id) as GroupBookingItemModel;
      stateBookingItem.isInGroup = false;
      commit.setBookingItems(state.bookingItems);
    },
    async saveGroup(context) {
      const { commit, state, rootDispatch } = _moduleActionContext(context);
      await rootDispatch.failIfRequestsInProgress();
      await saveBookingItemGroup(
        state.groupId,
        state.comment as string,
        state.bookingItems.filter((v) => v.isInGroup).map((v) => v.id)
      );
      commit.setIsDialog(false);
      await rootDispatch.bookings.getBookingsTable();
    },
  },
});

export default BookingsGroupModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, BookingsGroupModule);
const _moduleActionContext = (context: any) => moduleActionContext(context, BookingsGroupModule);
